import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';

const Sorter = ({ sort }) => {
  const renderSort = () => {
    if (typeof sort === 'boolean') {
      return <FaSort />;
    }

    if (sort === 'asc') {
      return <FaSortUp />;
    }

    if (sort === 'desc') {
      return <FaSortDown />;
    }
    return null;
  };

  return <div className="inline-flex">{renderSort()}</div>;
};

export default Sorter;
